import { TanksPage } from "../views/Tanks/TanksPage";
import { TanksPage_ } from "views/Tanks/TanksPage_";
import { TanksByStationsV2 } from "../views/Tanks/TanksByStationV2";

import LocalGasStationIcon from "@material-ui/icons/LocalGasStation";

export const tanksRoutes = [
  {
    collapse: true,
    name: "Tanques",
    icon: LocalGasStationIcon,
    state: "pageTankSection",
    inSidebar: true,
    isProtected: true,
    rule: "TANKS",
    views: [
      {
        path: "/tanques-list",
        name: "Listado de Tanques",
        mini: "TQ",
        component: TanksPage_,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "TANKS",
      },
      {
        path: "/tanques-planta",
        name: "Asignación de Tanques",
        mini: "TP",
        component: TanksByStationsV2,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "TANKS",
      },
    ],
  },
]